/**
 * Labstep
 *
 * @module components/Resource/Form/ShowEdit/Amount
 * @desc ShowEdit for Resource Location
 */

import classnames from 'classnames';
import styles from 'labstep-web/components/ProtocolValue/Form/ShowEdit/AmountUnit/styles.module.scss';
import {
  fieldResourceItemAmount,
  getFieldResourceItemUnit,
} from 'labstep-web/components/ResourceItem/Form/fields';
import { Flex } from 'labstep-web/core/Flex';
import { FormShowEditSelect } from 'labstep-web/core/Form/ShowEdit/Select';
import stylesShowEdit from 'labstep-web/core/Form/ShowEdit/styles.module.scss';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { IResourceItemFormShowEditAmountProps } from './types';

export const ResourceItemFormShowEditAmount: React.FC<
  IResourceItemFormShowEditAmountProps
> = ({ resourceItem, disabled }) => (
  <Flex className={styles.container}>
    <ShowEditText
      entityName={resourceItem.entityName}
      entity={resourceItem}
      field={fieldResourceItemAmount}
      disabled={disabled}
    >
      {resourceItem.amount}
    </ShowEditText>
    <FormShowEditSelect
      dataCy="components/Resource/Form/ShowEdit/Amount:Unit"
      creatable={{
        formatCreateLabel: (input) => `Custom unit "${input}"`,
      }}
      entity={resourceItem}
      field={getFieldResourceItemUnit(
        false,
        resourceItem.unit || undefined,
      )}
      disabled={disabled}
      customShow={({ toggle }) => (
        <div
          data-cy="components/Resource/Form/ShowEdit/Amount:Unit"
          data-testid="show-edit-toggle"
          onClick={toggle}
          className={classnames(
            stylesShowEdit.toggleContainer,
            'toggle',
          )}
        >
          {resourceItem.unitDisplayValue}
        </div>
      )}
    >
      {resourceItem.unitDisplayValue}
    </FormShowEditSelect>
  </Flex>
);
